import { useState } from 'react';
import { useFormik } from 'formik';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';
import { step1ValidationSchema } from './step1.validation';

export const useStep1 = () => {
  const { formulario, setPartialForm, salvarRascunho } =
    useFormularioSecretariaMunicipalAgriculturaStore();

  const [submittedOnce, setSubmittedOnce] = useState<boolean>(false);
  const stepAtual = formulario?.step_atual ?? 1;
  const totalSteps = 8;

  const handleSave = async (values: any) => {
    setPartialForm('tipo_unidade_administrativa', values.tipo_unidade_administrativa);
    setPartialForm('nome_secretaria', values.nome_secretaria);
    setPartialForm('endereco', values.endereco);
    setPartialForm('endereco_numero', values.endereco_numero);
    setPartialForm('bairro', values.bairro);
    setPartialForm('cep', values.cep);
    setPartialForm('email', values.email);
    setPartialForm('telefone', values.telefone);
    setPartialForm('telefone2', values.telefone2);
    setPartialForm('nome_responsavel', values.nome_responsavel);
    setPartialForm('email_responsavel', values.email_responsavel);
  };

  const formik = useFormik({
    initialValues: {
      tipo_unidade_administrativa: formulario?.tipo_unidade_administrativa ?? null,
      nome_secretaria: formulario?.nome_secretaria ?? null,
      endereco: formulario?.endereco ?? null,
      endereco_numero: formulario?.endereco_numero ?? '',
      bairro: formulario?.bairro ?? null,
      cep: formulario?.cep ?? null,
      email: formulario?.email ?? null,
      telefone: formulario?.telefone ?? null,
      telefone2: formulario?.telefone2 ?? null,
      nome_responsavel: formulario?.nome_responsavel ?? null,
      email_responsavel: formulario?.email_responsavel ?? null,
    },
    validationSchema: step1ValidationSchema,
    validateOnChange: true,
    validateOnBlur: submittedOnce,
    onSubmit: async (values: any) => {
      await handleSave(values);
      setPartialForm('step_atual', stepAtual + 1);
      await salvarRascunho();
    },
  });

  const handleAvancar = async () => {
    setSubmittedOnce(true);
    await formik.submitForm();
  };

  const handleVoltar = async () => {
    setPartialForm('step_atual', Math.max(1, stepAtual - 1));
  };

  return {
    formik,
    handleAvancar,
    handleVoltar,
    stepAtual,
    totalSteps,
  };
};
